import { useEffect, useState } from "react";
import ReviewsCard from "./ReviewCard";
import { motion } from "framer-motion";
import { axiosInstance } from "../config/axios";

const CustomerReviews = () => {
  const [reviews, setReviews] = useState(null);

  const getReviews = async () => {
    try {
      const data = await axiosInstance.get("/reviews");
      setReviews(data.data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getReviews();
  }, []);

  return (
    <div className="flex flex-col justify-center items-center reviews w-full py-[50px] lg:py-[100px]">
      <motion.h2
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{
          duration: 0.7,
        }}
        className="uppercase text-center text-[35px] lg:text-[50px] text-white mb-[20px] lg:mb-[40px]"
      >
        CUSTOMER REVIEWS
      </motion.h2>
      <div className="w-[85%] grid grid-cols-1 lg:grid-cols-3 gap-[25px]">
        {reviews?.map((item, index) => (
          <ReviewsCard
            order={index + 1}
            key={index}
            name={item.name}
            text={item.text}
          />
        ))}
      </div>
    </div>
  );
};

export default CustomerReviews;
